import type { ViewFilter } from '@/shared/types/projectData';

const hasNonEmptyString = (value: unknown): value is string =>
  typeof value === 'string' && value.trim().length > 0;

const isNonEmptyArray = (value: unknown): value is unknown[] =>
  Array.isArray(value) && value.length > 0;

const hasValidDateRange = (value: unknown): value is NonNullable<ViewFilter['dateRange']> =>
  !!value &&
  typeof value === 'object' &&
  hasNonEmptyString((value as Partial<NonNullable<ViewFilter['dateRange']>>).start) &&
  hasNonEmptyString((value as Partial<NonNullable<ViewFilter['dateRange']>>).end);

export function normalizeViewFilter(filters: ViewFilter): ViewFilter {
  const normalized: ViewFilter = {};

  if (isNonEmptyArray(filters.types)) normalized.types = filters.types;
  if (isNonEmptyArray(filters.statuses)) normalized.statuses = filters.statuses;
  if (isNonEmptyArray(filters.priorities)) normalized.priorities = filters.priorities;
  if (isNonEmptyArray(filters.assignees)) normalized.assignees = filters.assignees;
  if (isNonEmptyArray(filters.tags)) normalized.tags = filters.tags;
  if (isNonEmptyArray(filters.workstreams)) normalized.workstreams = filters.workstreams;
  if (isNonEmptyArray(filters.developmentRoles)) normalized.developmentRoles = filters.developmentRoles;
  if (isNonEmptyArray(filters.visibilityTiers)) normalized.visibilityTiers = filters.visibilityTiers;
  if (isNonEmptyArray(filters.client)) normalized.client = filters.client;
  if (hasValidDateRange(filters.dateRange)) normalized.dateRange = filters.dateRange;
  if (hasNonEmptyString(filters.searchQuery)) normalized.searchQuery = filters.searchQuery.trim();

  return normalized;
}

export function getActiveFilterCount(filters: ViewFilter, searchQuery?: string): number {
  const normalized = normalizeViewFilter(filters);
  const baseCount = Object.keys(normalized).filter(key => key !== 'searchQuery').length;
  const effectiveSearch = searchQuery === undefined ? normalized.searchQuery : searchQuery;
  return baseCount + (hasNonEmptyString(effectiveSearch) ? 1 : 0);
}

export function hasActiveFilters(filters: ViewFilter, searchQuery?: string): boolean {
  return getActiveFilterCount(filters, searchQuery) > 0;
}
